<template>
  <div
    class="assessment-config-item-view transition duration-150 ease-out d-flex flex-column"
    :class="isHovering ? 'area-student' : ''"
    @drop.prevent.stop="dragDrop"
    @dragover.prevent="dragEnter"
    @dragenter.prevent="dragEnter"
    @dragleave.prevent="dragLeave"
  >
    <div
      class="my-2 pb-2 d-flex justify-content-between"
      style="border-bottom: 1px solid #eee"
    >
      <span
        v-if="studentsPerTimeslotFull"
        class="fa fa-check fa-lg open flex-grow-1"
      />
      <span
        v-else
        class="fa fa-pencil-square-o fa-lg flex-grow-1 no-places"
      />
      <span
        class="flex-grow-1"
        style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden"
      >
        {{ duration }} min
      </span>
      <span
        class="fa fa-info-circle fa-lg align-items-end text-right cursor-pointer"
        tabindex="0"
        @click="edit"
      />
    </div>
    <div
      class="flex-grow-1"
      style="align-content: center"
    >
      <AssessmentConfigStudentItemView
        :students="students"
        :event-id="assessmentConfigItem.event.id"
      />
      <div
        v-for="place in places"
        class="area d-flex flex-column mb-2 flex-grow-1"
      />
    </div>
    <div
      class="d-flex justify-content-between pb-2 pt-2"
      style="border-top: 1px solid #eee; font-size: 12px"
    >
      <div
        class="flex-grow-1 ps-2 pe-2"
        style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden"
      >
        {{ lecturers.join(', ') }}
      </div>
      <div
        class="flex-grow-1 text-right pe-2 ps-2"
        style="white-space: nowrap; text-overflow:ellipsis; overflow:hidden"
      >
        {{ classrooms.join(', ') }}
      </div>
    </div>
  </div>
</template>

<script>
import toast from '@/services/toast'
import { mapState } from 'vuex'
import AssessmentConfigStudentItemView
  from '@/employees/components/AssessmentConfig/view/AssessmentConfigStudentItemView'

export default {
  name: 'AssessmentConfigItemView',
  components: {
    AssessmentConfigStudentItemView,
  },
  props: {
    assessmentConfigItem: {
      required: true,
      type: Object,
    },
    assessmentConfig: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      isHovering: false,
    }
  },
  computed: {
    ...mapState({
      lecturers (state) {
        return this.assessmentConfigItem.event?.lecturers?.map((id) => state.lecturers.lecturers[id].name) ?? []
      },
      classrooms (state) {
        return this.assessmentConfigItem.event?.classrooms?.map((id) => state.classrooms.classrooms[id].name) ?? []
      },
      students (state) {
        return this.assessmentConfigItem.event.students
          ? this.assessmentConfigItem.event.students.map(studentId => state.students.students[studentId])
          : []
      },

      duration () {
        const end = moment(this.assessmentConfigItem.event.endtime)
        const start = moment(this.assessmentConfigItem.event.starttime)
        return moment.duration(end.diff(start)).asMinutes()
      },

    }),
    studentsPerTimeslotFull () {
      return this.assessmentConfig.config_data.students_per_timeslot <= this.students.length
    },
    places () {
      let i = 0
      const pl = this.assessmentConfig.config_data.students_per_timeslot - this.students.length
      const places = []
      while (i < pl) {
        places.push(i)
        i = i + 1
      }
      return places
    },
  },
  methods: {
    edit () {
      this.$emit('edit', this.assessmentConfigItem)
    },
    dragDrop (event) {
      const payLoad = JSON.parse(event.dataTransfer.getData('text/plain'))

      if (!this.studentsPerTimeslotFull) {
        this.$store.dispatch('moveStudentToEvent',
          {
            data: {
              from: payLoad?.eventId,
              to: this.assessmentConfigItem.event.id,
              student: payLoad.studentId,
            },
          },
        ).catch((e) => {
          return toast.warning(Lang.get('errors.move_not_possible'))
        }).finally(() => {
          this.isHovering = false
        })
      }
    },
    dragEnter (event) {
      if (!this.studentsPerTimeslotFull) {
        this.isHovering = true
      }
    },
    dragLeave (event) {
      if (!this.studentsPerTimeslotFull) {
        this.isHovering = false
      }
    },
  }
  ,
}
</script>

<style scoped>
.assessment-config-item-view {
  z-index: 20;
  user-select: none;
  padding: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 14px;
  line-height: 1.5rem;
  font-weight: 700;
  border-radius: 0.375rem;
  background: white;
  height: 100%;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-150 {
  transition-duration: 150ms;
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.open {
  color: #117733;
}

.no-places {
  color: #a69308;
}

.area {
  background: white;
  border-color: darkgray;
  border-radius: 0.375rem;
  border-style: dashed;
  z-index: 999;
  border-width: 1px;
  height: 35px;
}

.area-student {
  background: rgb(147, 221, 241);
}
</style>
